import { Grid } from "@mui/material";
import Libelle from "../../../_i18n/fr.json";
import Titre from "../../../components/titre/Titre";
import BlocFonctions from "./BlocFonctions";
import ContactForm from "./ContactForm";

function Landing() {
  // <Link to="/protection-des-donnees">
  //   {Libelle.pageLanding.rgpd}
  // </Link>;
  return (
    <>
      <Grid
        container
        justifyContent="center"
        className={"bigTitleLanding bigTitle"}
      >
        <Titre libelle={Libelle.pageLanding.h1} variant="h1" />
        <Titre libelle="avec vertuloo votre plateforme digitale" variant="h2" />
      </Grid>
      <div className={"contactContainer"}>
        <div className={"grosRond"} />
        <iframe
          className={"iframeYoutube"}
          title="youtube"
          width="645"
          height="365"
          src="https://www.youtube-nocookie.com/embed/R6eiU7S4mlE"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
        <ContactForm />
      </div>
      <BlocFonctions />
      <div className={"container"} />
    </>
  );
}

export default Landing;
